
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/map",
      function () {
        return require("private-next-pages/partners/map.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/map"])
      });
    }
  